module.exports = {
  Lp : '/package/data/',
  LpAlias : '/package/alias/',
  LeadGenration: '/lead/generate-lead-by-user/',
  PACKAGE: '/package/data_web/',
  BOOKING_SLOT_COLLECTION_DATE: '/booking/booking_slot_collection_date/',
  PatientDetails : '/auth/shortprofile/',
  doctorBooking : '/booking/open-doctor_cunsultation/',
  serviceQuestions: '/service/questions/',
  serviceQuestionsPost:'/service/answers/create/',
  serviceUserExisting :'/service/feedbacksubmit/',
  redoPostWhatsappOtp :'/notification/send-whatsapp-otp/',
  redoPostForm :'/notification/create-lead-user/',
  redoPackages:'/package/redo-package-list/',
  redoFaqs:'/redoapp/faq-list/',
  redoVerifyOtp:'/notification/verify-whatsapp-otp/',
  ourDoctors:'/career/our-doctors-list/',

  // Imaging Doctor Listing
  imagineCenterAddress: '/center/center-address/',
  imagineCenterData: '/center/data/',
  imagingCheapPackage : '/package/cheapest_package/',
  patchBankdetailApi:'/payment/refund/bank-details/', 
  callBackLead:'/booking/prescription_upload/?lead=true', 
};